import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/ui/our-experience/webp/reinvox-t-duo.webp")